import React, { useState } from 'react';

export default function LoginForm({ onSubmit }) {
    const [user, setUser] = useState('');
    const [password, setPassword] = useState('');

    return (
        <div className={'form'}>
            <div className={'form-group'}>
                <input className={'form-control'} placeholder={'User'} value={user} onChange={e => setUser(e.target.value)} />
            </div>
            <div className={'form-group'}>
                <input className={'form-control'} type={'password'} placeholder={'Password'} value={password} onChange={e => setPassword(e.target.value)} />
            </div>
            <button className={'btn btn-primary btn-block'} disabled={!user || !password} onClick={e => onSubmit(user, password)}>Log in</button>
        </div>
    )
}